import { Component } from '@angular/core';

@Component({
  selector: 'app-soon',
  standalone: true,
  imports: [],
  templateUrl: './soon.component.html',
  styleUrl: './soon.component.less'
})
export class SoonComponent {

}
